import { Injectable } from '@angular/core';
import { InvoiceServiceBase } from 'scaletech-invoices';
import { HttpClient } from '@angular/common/http';
import { WebApiService, StarbaseLoginService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class InvoiceDataService extends InvoiceServiceBase {

  constructor(http: HttpClient, webApi: WebApiService, loginSvc: StarbaseLoginService) {
    super(http, webApi, loginSvc);
  }
}
